// const baseUrl = process.env.NODE_ENV === 'production' ? '//api-e-contract-client.jimujia.miaowudz.com' : '/api'
const baseUrl = process.env.NODE_ENV === 'production' ? '//api-contract-client.jimujia.com' : '/api'

// const baseUrl = 'http://1011.zicp.net'

const apiUrls = {
  // 首页用户基本信息接口
  user: baseUrl + '/user/user/index',
  // 短信验证码接口
  loginSms: baseUrl + '/user/user/getsms',
  // 验证码登录接口
  userLogin: baseUrl + '/user/user/login',
  // 合同预览页接口
  contract: baseUrl + '/contract/contract/index',
  // 用户信息
  userInfo: baseUrl + '/user/user/get_user_info',
  // 合同预览页接口
  authent: baseUrl + '/user/user/authent',
  // 合同成功页接口
  contractSuccess: baseUrl + '/contract/contract/locking',
  // 发送电子邮件
  sendEmail: baseUrl + '/contract/contract/send_email'
}

export default apiUrls
